import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AppConstants } from "src/app/app.constants";
import { Observable, of } from "rxjs";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class AnticipatedDateService {

  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  getAmfdAllData(new_data, email): Observable<any> {
    const params = new HttpParams()
      .set('new_data', new_data)
      .set('user_email', email.toString());
    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.ALL_AMFD_DATA.ALL_AMFD_NEW_DATA}`, { params }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
